/* eslint-disable import/prefer-default-export */
import { RevolutionsVessel } from '../../models/vessels/vessel.model';
import { wrapRequest } from '../base';

export const getRevolutionsVessel = async (
  imo: string
): Promise<RevolutionsVessel> =>
  wrapRequest('get', 'north_standard', `/north-standard/vessels/${imo}`);
